import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import './styles/app.css'; // Here

createApp(App).mount('#app')
